// extracted by mini-css-extract-plugin
export default {"content":"gDO3tqgH","buttonWrapper":"SCRKWYe1","footerButton":"_xKVE3tH","modalSticker":"vnMzCftS"};